var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"invite-code-loading"},[_c('div',[_c('img',{staticClass:"logo",attrs:{"src":_vm.nowServingLogo}})]),_c('div',{staticClass:"mb-m"},[_c('smd-loading-spinner')],1),_c('p',[_vm._v("Checking invite code...")])])}
var staticRenderFns = []

export { render, staticRenderFns }